import Component from 'can/component/component';
import template from './vc-user-profile.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import can from 'can';
import vcProfileService from 'scripts/services/vc-profile-service';
import states from './list-usa-states.json';
import countries from './list-countries.json';
import {
    init as initWebAuth,
    getUserInfo,
    logout as auth0Logout,
} from 'scripts/services/auth0';
import localStorageService from 'scripts/services/localstorage-service';
import 'jquery-mask-plugin';
import dayjs from 'dayjs';

const ENTER_KEY_CODE = 13;
const homePageUrl = window.globalSettings.vc.auth0.mainUrl;
let prevData = {
    email: '',
    address: '',
    firstName: '',
    lastName: '',
    birthdate: '',
    phone: '',
    gender: '',
    zip: '',
    country: '',
    state: '',
    city: '',
    smsSubscription: false,
    emailSubscription: false,
    attendedChampionships: '',
    isUsgaMember: '',
    howHearVC: '',
    customDate: '',
};

Component.extend({
    tag: 'vc-user-profile',
    template: template,
    viewModel: {
        define: {
            firstName: {
                type: 'string',
                value: '',
            },
            lastName: {
                type: 'string',
                value: '',
            },
            email: {
                type: 'string',
                value: '',
            },
            phone: {
                type: 'string',
                value: '',
            },
            birthdate: {
                type: 'string',
                value: '',
            },
            gender: {
                type: 'string',
                value: '',
            },
            address: {
                type: 'string',
                value: '',
            },
            city: {
                type: 'string',
                value: '',
            },
            state: {
                type: 'string',
                value: '',
            },
            zip: {
                type: 'string',
                value: '',
            },
            country: {
                type: 'string',
                value: '',
            },
            attendedChampionships: {
                type: 'string',
                value: '',
            },
            isUsgaMember: {
                type: 'string',
                value: '',
            },
            howHearVC: {
                type: 'string',
                value: '',
            },
            emailSubscription: {
                type: 'boolean',
                value: false,
            },
            smsSubscription: {
                type: 'boolean',
                value: false,
            },
            errorCountry: {
                type: 'string',
                value: '',
            },
            states: {
                Type: can.Map,
                Value: can.Map,
            },
            countries: {
                Type: can.Map,
                Value: can.Map,
            },
            isDataChanged: {
                type: 'boolean',
                value: false,
            },
            isAuthorized: {
                type: 'boolean',
                value: false,
            },
            isUnitedStates: {
                type: 'boolean',
                value: false,
            },
            customDate: {
                type: 'string',
                value: '',
            },
            wrongDate: {
                type: 'string',
                value: '',
            },
        },
    },
    events: {
        async inserted() {
            const accessToken = localStorageService.getItem('access_token');
            initWebAuth();
            if (!(await getUserInfo(accessToken))) {
                window.location.href = window.globalSettings.vc.auth0.mainUrl;
                return;
            }
            this.viewModel.attr('isAuthorized', true);

            DomEventsManager.subscribe(this);
            vcProfileService
                .fetch('GET')
                .then(
                    (results) => {
                        const data =
                            typeof results === 'string'
                                ? JSON.parse(results).data
                                : results.data;

                        if (typeof data === 'object') {
                            prevData = Object.assign(prevData, data);
                            prevData.customDate = prevData.birthdate;
                            this.setFormData(data);

                            this.viewModel.attr(
                                'isUnitedStates',
                                this.isUnitedStates(data.country),
                            );
                        }
                    },
                    (error) => console.error('vcProfileService', error),
                )
                .catch((err) => console.error('GET catch', err));

            this.viewModel.attr('states', states);
            this.viewModel.attr('countries', countries);

            $('.js-mask-phone').mask('000-000-0000000000');
            $('.js-mask-zip').mask('000000');
            $('.js-mask-date').mask('0000-00-00');
        },

        setFormData(data) {
            Object.entries(data).forEach(([key, val]) => {
                this.viewModel.attr(key, val);
            });
            this.viewModel.attr('customDate', data.birthdate);
        },

        detectChangedData($el) {
            if (!this.viewModel.attr('isDataChanged') && $el) {
                if (prevData[$el.name] !== $el.value) {
                    this.viewModel.attr('isDataChanged', true);
                }
            }
        },

        setCheckBox(key, val, $form) {
            const $input = $form.find(`.js-checkbox-input[name="${key}"]`);
            if ($input) {
                $input.prop('checked', val);
                $input.parent().attr('aria-checked', val);
            } else {
                console.error(`.js-checkbox-input ${key} did not find`);
            }
        },

        setStringVal(key, val, $form) {
            let $input = $form.find(
                `.vc-profile-form__item-field[name="${key}"]`,
            );
            if ($input) {
                $input.val(val);
            } else {
                $input = $form.find(`.js-mask-date[name="${key}"]`);
                if ($input) {
                    $input.val(val);
                } else {
                    console.error(
                        `.vc-profile-form__item-field ${key} did not find`,
                    );
                }
            }
        },

        showErrors(input) {
            let isErrorExist = false;
            const $el = $(input);
            const $err = $el.parent().find('.vc-profile-form__error-desc');

            if (input.checkValidity()) {
                $err.hide();
                $el.removeClass('error-message');
            } else {
                $err.show();
                $el.addClass('error-message');
                isErrorExist = true;
            }

            return isErrorExist;
        },

        isDateCorrect(el, date = null) {
            const $form = $(el.get(0)).parents('form');
            const $customInput = $($form.find('.js-mask-date').get(0));
            const $err = $customInput
                .parent()
                .parent()
                .find('.vc-profile-form__error-desc');
            let isDateCorrect = false;
            date = date || $customInput.val();
            if (date && !dayjs(date, 'YYYY-MM-DD', true).isValid()) {
                this.viewModel.attr('wrongDate', 'Wrong date');
                $err.show();
                $customInput.parent().addClass('error-message');
            } else {
                $err.hide();
                $customInput.parent().removeClass('error-message');
                isDateCorrect = true;
                this.viewModel.attr('wrongDate', '');
            }
            return isDateCorrect;
        },

        logOutUser() {
            localStorageService.removeItem('access_token');
            auth0Logout(homePageUrl);
        },

        '.js-vc-profile-form [type="submit"] click.formValidation'(el, event) {
            const $form = $(el.get(0)).parents('form');
            const $inputs = $form.find('input[required]');
            let isErrorExist = false;

            $inputs.each((index, input) => {
                isErrorExist = this.showErrors(input);
            });
            if (this.viewModel.attr('errorCountry')) {
                isErrorExist = true;
            }
            if (!this.isDateCorrect(el)) {
                isErrorExist = true;
            }
            const $wrong = $form.find('.vc-profile-form__alert.wrong-fields');
            const $success = $form.find(
                '.vc-profile-form__alert.success-message',
            );
            $success.hide();
            if (isErrorExist) {
                $wrong.css('display', 'flex');
                event.preventDefault();
                return;
            } else {
                $wrong.hide();
            }

            const formData = new FormData($form.get(0));
            const data = Object.fromEntries(formData.entries());
            data.memberType = 'Victory Club';
            data.smsSubscription = data.smsSubscription === 'on' ? true : false;
            data.emailSubscription =
                data.emailSubscription === 'on' ? true : false;
            delete data.customDate;
            data.state = data.state || '';
            vcProfileService
                .fetch('POST', data)
                .then(
                    () => {
                        $success.css('display', 'flex');
                        this.viewModel.attr('isDataChanged', false);
                        if (prevData.email !== data.email) {
                            this.logOutUser();
                        }
                        prevData = Object.assign({}, data);
                        prevData.customDate = prevData.birthdate;
                    },
                    (error) => console.error('error', error),
                )
                .catch((err) => console.error('catch', err));
        },

        '.vc-profile-form__item-field keypress'($element, event) {
            const keyPressed = event.keyCode || event.which;
            if (keyPressed === ENTER_KEY_CODE) {
                event.preventDefault();
            }
        },

        '.vc-profile-form__item-field change'($el) {
            this.detectChangedData($el.get(0));
        },

        '.js-logout-btn click'($element, event) {
            event.preventDefault();
            this.logOutUser();
        },

        '.btn-cancel click'(el, event) {
            event.preventDefault();

            const $form = $(el.get(0)).parents('form');
            Object.entries(prevData).forEach(([key, val]) => {
                if (typeof val === 'boolean') {
                    this.setCheckBox(key, val, $form);
                } else {
                    this.setStringVal(key, val, $form);
                }
            });

            const $inputs = $form.find('input[required]');
            $inputs.each((index, input) => {
                this.showErrors(input);
            });
            this.isDateCorrect(el);

            this.viewModel.attr('isDataChanged', false);
        },

        '.js-close-success click'($el, event) {
            event.preventDefault();
            $el.parent().hide();
        },

        '.js-checkbox-btn click'($element, event) {
            event.preventDefault();
            const $input = $element.find('.js-checkbox-input');
            const isChecked = $input.prop('checked');
            $input.prop('checked', !isChecked);
            $element.attr('aria-checked', !isChecked);
            this.detectChangedData($element.get(0));
        },

        '.js-date-input change'(input) {
            const date = $(input.get(0)).val();
            if (this.isDateCorrect(input, date)) {
                this.viewModel.attr('customdate', date);
                const $form = $(input.get(0)).parents('form');
                $form.find('.js-custom-date').val(date);
            }
        },

        '.js-mask-date blur'(input) {
            const date = input.get(0).value;
            if (this.isDateCorrect(input, date)) {
                this.viewModel.attr('birthdate', date);
            }
            this.detectChangedData(input.get(0));
        },

        '.js-vc-profile-form input[required] blur'($el) {
            this.showErrors($el.get(0));
        },

        '.js-datalist-input change'(input) {
            let isCountryExist = false;
            const $el = $(input.get(0));
            const $err = $el.parent().find('.vc-profile-form__error-desc');
            const text = input.get(0).value;
            for (let option of countries) {
                if (!text || option.value === text) {
                    isCountryExist = true;
                }
            }
            const isUnitedStates = this.isUnitedStates(text);
            if (isCountryExist) {
                $err.hide();
                $el.removeClass('error-message');
                this.viewModel.attr('errorCountry', '');
                this.viewModel.attr('isUnitedStates', isUnitedStates);
                if (!isUnitedStates) {
                    const $form = $el.parents('form');
                    this.setStringVal('state', '', $form);
                }
            } else {
                this.viewModel.attr('errorCountry', input.get(0).value);
                $err.show();
                $el.addClass('error-message');
            }
        },

        isUnitedStates: function(country) {
            return country === 'United States';
        },

        removed: function() {
            DomEventsManager.unsubscribe(this);
        },
    },
});
